<template>
    <div class="banner">
        <div class="carousel">
            <el-carousel :interval="5000" height="380px">
                <el-carousel-item v-for="(item, index) in data" :key="index">
                    <ads-item class="carousel-item" :data="item" font-size="16px" offset="18px"></ads-item>
                </el-carousel-item>
            </el-carousel>
        </div>

    </div>
</template>

<script>
import AdsItem from './ads-item';

export default {
    props: {
        data: {
            type: Array,
            default: () => ([]),
        },
    },
    components: {
        AdsItem,
    },
    data: () => ({
        homeA: [],
    }),
    computed: {},
    mounted() {
        
    },
    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.banner {
    overflow: hidden;

    .carousel {
        // float: left;
        width: 100%;
        height: 370px;
        z-index: 1000;

        .carousel-item {
            width: 100%;
            height: 100%;
        }

        ::v-deep .el-carousel__indicators {
            // 指示器
            left: unset;
            transform: unset;
            right: 2%;
        }

        ::v-deep .el-carousel__button {
            // 指示器按钮
            width: 20px;
            height: 4px;
            border: none;
            // border-radius: 50%;
            background-color: rgba(0, 0, 0, 0.2);
        }
        ::v-deep .is-active .el-carousel__button {
            // 指示器激活按钮
            background: #8a1f94;
        }

        ::v-deep .el-carousel__indicators--horizontal {
            bottom: 20px;
            right: -22px;
            transform: translateX(-50%);
        }
    }
}
</style>